/* eslint-disable no-case-declarations */
import { StartRenderType } from 'rcx_adapter';
import { generateTimestampedUrl } from 'rcx_adapter/src/util';

import { GlobalActionTypes } from './actions';
import type { GlobalState, ReducerAction } from './types';
import { SecondIframeState } from '../constants';

export const initialState: GlobalState = {
    secondIframe: {
        state: SecondIframeState.Hidden,
        currentType: '',
        scriptUrl: '',
        script: null,
        digital: null,
        isLoading: false,
    },
};

export const globalReducer = (state: any, action: ReducerAction<GlobalActionTypes>) => {
    switch (action.type) {
        case GlobalActionTypes.SetScriptUrl:
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    scriptUrl: generateTimestampedUrl(action.payload),
                },
            };
        case GlobalActionTypes.UpdateScriptUrlTimeStamp:
            const currentTimestamp = Math.floor(Date.now() / 1000);
            const newScriptUrl = state.secondIframe.scriptUrl
                ? state.secondIframe.scriptUrl.replace(/&ts=\d+/, '') + `&ts=${currentTimestamp}`
                : '';
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    scriptUrl: newScriptUrl,
                },
            };
        case GlobalActionTypes.ChangeSecondIframeState:
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    state: action.payload,
                },
            };
        case GlobalActionTypes.ResetSecondIframeState:
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    state: SecondIframeState.Hidden,
                    currentType: '',
                    script: null,
                    digital: null,
                },
            };
        case GlobalActionTypes.SetSecondIframeScript:
            const newTypeForScript = action.payload
                ? StartRenderType.SCRIPT
                : state.secondIframe.digital
                  ? StartRenderType.DIGITAL
                  : '';
            const newScript = !action.payload
                ? null
                : action.payload.renderId !== state.secondIframe.script?.renderId
                  ? action.payload
                  : { ...state.secondIframe.script, ...action.payload };
            const newState =
                newTypeForScript === StartRenderType.SCRIPT &&
                newScript?.renderId === state.secondIframe.script?.renderId &&
                state.secondIframe.state !== SecondIframeState.Hidden
                    ? state.secondIframe.state
                    : SecondIframeState.Expand;

            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    state: newTypeForScript ? newState : SecondIframeState.Hidden,
                    currentType: newTypeForScript,
                    script: newScript,
                },
            };
        case GlobalActionTypes.UpdateSecondIframeScript:
            if (action.payload.renderId !== state.secondIframe.script?.renderId) {
                return state;
            }
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    script: {
                        ...state.secondIframe.script,
                        ...action.payload,
                    },
                },
            };
        case GlobalActionTypes.UpdateSecondIframeLoading:
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    isLoading: action.payload,
                },
            };
        case GlobalActionTypes.SetSecondIframeDigital:
            const newTypeForDigital = action.payload
                ? StartRenderType.DIGITAL
                : state.secondIframe.script
                  ? StartRenderType.SCRIPT
                  : '';
            if (
                action.payload?.renderId === state.secondIframe.digital?.renderId &&
                action.payload?.url === state.secondIframe.digital?.url &&
                newTypeForDigital === state.secondIframe.currentType
            ) {
                return state;
            }
            return {
                ...state,
                secondIframe: {
                    ...state.secondIframe,
                    state: newTypeForDigital ? SecondIframeState.Expand : SecondIframeState.Hidden,
                    currentType: newTypeForDigital,
                    digital: action.payload ? action.payload : null,
                },
            };
        default:
            return state;
    }
};
